// this is an autogenerated file from DesignSystem/GenerateLettersModal/query-get-document-templates.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_GenerateLettersModal($org_id: uuid!) {
  documents_get_document_templates_for_org(args: { org_id: $org_id }) {
    id: _id
    name
  }
}

`